import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { css } from '@emotion/react';
import { isRecurringContributor, getLastOneOffContributionTimestamp, shouldHideSupportMessaging, hasCmpConsentForArticleCount, MODULES_VERSION, hasOptedOutOfArticleCount, lazyFetchEmailWithTimeout, hasCmpConsentForBrowserId, } from '@root/src/web/lib/contributions';
import { initPerf } from '@root/src/web/browser/initPerf';
import { submitComponentEvent, } from '@root/src/web/browser/ophan/ophan';
import { setAutomat } from '@root/src/web/lib/setAutomat';
import { getEpic, getEpicViewLog } from '@guardian/support-dotcom-components';
import { cmp } from '@guardian/consent-management-platform';
import { getCookie, storage } from '@guardian/libs';
const wrapperMargins = css `
	margin: 18px 0;
	clear: both;
`;
const buildPayload = async (data) => ({
    tracking: {
        ophanPageId: window.guardian.config.ophan.pageViewId,
        platformId: 'GUARDIAN_WEB',
        clientName: 'dcr',
        referrerUrl: window.location.origin + window.location.pathname,
    },
    targeting: {
        contentType: data.contentType,
        sectionId: data.sectionId,
        shouldHideReaderRevenue: data.shouldHideReaderRevenue,
        isMinuteArticle: data.isMinuteArticle,
        isPaidContent: data.isPaidContent,
        tags: data.tags,
        showSupportMessaging: !shouldHideSupportMessaging(data.isSignedIn || false),
        isRecurringContributor: isRecurringContributor(data.isSignedIn || false),
        lastOneOffContributionDate: getLastOneOffContributionTimestamp(),
        epicViewLog: getEpicViewLog(storage.local),
        weeklyArticleHistory: await data.asyncArticleCount,
        hasOptedOutOfArticleCount: await hasOptedOutOfArticleCount(),
        mvtId: Number(getCookie({ name: 'GU_mvt_id', shouldMemoize: true })),
        countryCode: data.countryCode,
        modulesVersion: MODULES_VERSION,
        url: window.location.origin + window.location.pathname,
        browserId: (await hasCmpConsentForBrowserId())
            ? data.browserId
            : undefined,
    },
});
export const canShowReaderRevenueEpic = async (data) => {
    const { isSignedIn, shouldHideReaderRevenue, isPaidContent, contributionsServiceUrl, idApiUrl, stage, } = data;
    if (shouldHideReaderRevenue || isPaidContent) {
        // We never serve Reader Revenue epics in this case
        return Promise.resolve({ show: false });
    }
    const dataPerf = initPerf('contributions-epic-data');
    dataPerf.start();
    const contributionsPayload = await buildPayload(data);
    const response = await getEpic(contributionsServiceUrl, contributionsPayload);
    const module = response.data?.module;
    if (!module) {
        return { show: false };
    }
    const fetchEmail = isSignedIn
        ? lazyFetchEmailWithTimeout(idApiUrl)
        : undefined;
    const hasConsentForArticleCount = await hasCmpConsentForArticleCount();
    return {
        show: true,
        meta: {
            module,
            fetchEmail,
            hasConsentForArticleCount,
            stage,
        },
    };
};
export const ReaderRevenueEpic = ({ module, fetchEmail, hasConsentForArticleCount, stage, }) => {
    const [Epic, setEpic] = useState();
    const openCmp = () => {
        cmp.showPrivacyManager();
    };
    useEffect(() => {
        setAutomat();
        const modulePerf = initPerf('contributions-epic-module');
        modulePerf.start();
        window
            .guardianPolyfilledImport(module.url)
            .then((epicModule) => {
            modulePerf.end();
            setEpic(() => epicModule.ContributionsEpic); // useState requires functions to be wrapped
        })
            .catch((error) => {
            const msg = `Error importing RR epic: ${error}`;
            // eslint-disable-next-line no-console
            console.log(msg);
            window.guardian.modules.sentry.reportError(new Error(msg), 'rr-epic');
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (Epic) {
        return (_jsx("div", Object.assign({ css: wrapperMargins }, { children: _jsx(Epic, Object.assign({}, module.props, { fetchEmail: fetchEmail, submitComponentEvent: submitComponentEvent, openCmp: openCmp, hasConsentForArticleCount: hasConsentForArticleCount, stage: stage }), void 0) }), void 0));
    }
    return null;
};
